import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutLaneHistoryTable extends Layout {
    sourceLaneHistory: DataSource;
    tableLaneHistory: Table;
}
